import * as React from "react";
import PageNavigation from "components/common/PageNavigation";
import { Row } from "components/bootstrap";
import { PAGE_NAVIGATION_TITLE } from "components/events/bindings";
const EventsPageNavigation = () => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAVIGATION_TITLE }));
export default EventsPageNavigation;
